export const selectorWallsCharacteristics = (state) => {
  const wallMaterial = state.wallsCharacteristics.wallMaterial;
  const density = state.wallsCharacteristics.density;
  const thickness = state.wallsCharacteristics.thickness;
  const thermalCoeff = state.wallsCharacteristics.thermalCoeff;

  return [wallMaterial, density, thickness, thermalCoeff]
}


export const isFullFilledWalls = (state) => {
  const wallMaterial = state.wallsCharacteristics.wallMaterial?.value;
  const density = state.wallsCharacteristics.density?.value;
  const thickness = state.wallsCharacteristics.thickness?.value;

  return !!wallMaterial && !!density && !!thickness
}